module.exports = __webpack_public_path__ + "img/rss.a2376d65.svg";